const createSh070InitState = () => ({
  orderInfo: [],
  orderDtlInfo: [],
});

const createSh070RequestState = () => ({});

const state = () => ({
  sh070Init: createSh070InitState(),
  sh070Request: createSh070RequestState(),
});

const mutations = {
  RESET_SH070_STATE(currentState) {
    currentState.sh070Init = createSh070InitState();
    currentState.sh070Request = createSh070RequestState();
  },
  SET_SH070_INIT(currentState, payload = {}) {
    currentState.sh070Init = payload || {};
  },
  MERGE_SH070_INIT(currentState, payload = {}) {
    currentState.sh070Init = Object.assign({}, currentState.sh070Init, payload);
  },
  SET_SH070_REQUEST(currentState, payload = {}) {
    currentState.sh070Request = payload || {};
  },
  MERGE_SH070_REQUEST(currentState, payload = {}) {
    currentState.sh070Request = Object.assign({}, currentState.sh070Request, payload);
  },
};

const getters = {
  sh070Init: currentState => currentState.sh070Init,
  sh070Request: currentState => currentState.sh070Request,
};

export {
  createSh070InitState,
  createSh070RequestState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
